import styled from "styled-components";

import { ANIMATION, SPACING } from "../../utils/constants";
import { InlineToggleAccent, InlineToggleTrackProps } from "./types";
import { BaseButton } from "../Button";

const accentColor = (accent: InlineToggleAccent) => {
  if (accent === "success") {
    return "var(--color-success)";
  }
  return "var(--color-primary)";
};

export const ToggleButton = styled(BaseButton)`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.sm}px;
  border: none;
  padding: ${SPACING.xs}px 0;
  background: transparent;
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-secondary);
  white-space: nowrap;
  cursor: pointer;
  transition: ${ANIMATION.transitions.all};
`;

export const ToggleTrack = styled.span<InlineToggleTrackProps>`
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
  border-radius: 10px;
  flex-shrink: 0;
  background: ${({ $checked, $accent }) =>
    $checked ? accentColor($accent) : "var(--color-gray-border)"};
  transition: background ${ANIMATION.duration.normal}
    ${ANIMATION.easing.standard};
`;

export const ToggleThumb = styled.span<{ $checked: boolean }>`
  position: absolute;
  top: 3px;
  left: 3px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--color-white);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transition: transform ${ANIMATION.duration.normal}
    ${ANIMATION.easing.easeOutExpo};
  transform: translateX(${({ $checked }) => ($checked ? "16px" : "0")});
`;

export const ToggleLabel = styled.span`
  letter-spacing: 0.01em;
`;
